import React, { Component } from 'react';

import { ajax_wrapper } from 'functions';
import { Form, TextInput, Container, Alert } from 'library';

class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            error: '',
            form_callback: null,
        };

        this.submit = this.submit.bind(this);
        this.callback = this.callback.bind(this);
    }

    submit(state, callback) {
        let data = {
            email: state['email'],
            password: state['password'],
        };
        data.email = data.email.toLowerCase();

        this.setState({ form_callback: callback }, () => {
            ajax_wrapper('POST', '/user/token/', data, this.callback);
        });
    }

    callback(value) {
        if ('error' in value) {
            if (value.error === 'Invalid Credentials') {
                this.setState({
                    error: (
                        <p>
                            Wrong Email or Password. If this is your first time
                            logging in, you may need to{' '}
                            <a href="/password_reset_request/">
                                reset your password first.
                            </a>
                        </p>
                    ),
                });
            } else {
                this.setState({ error: value.error });
            }

            this.state.form_callback();
        } else {
            localStorage.setItem('token', value.access);
            localStorage.setItem('refresh_token', value.refresh);
            localStorage.setItem('token_time', new Date());

            if (localStorage.getItem('redirect')) {
                let url = localStorage.getItem('redirect');
                localStorage.removeItem('redirect');
                window.location.href = url;
            } else {
                window.location.href = '/';
            }
        }
    }

    render() {
        let error = null;
        if (this.state.error !== '') {
            error = <Alert type="danger">{this.state.error}</Alert>;
        }
        return (
            <Container className="simple-card-container">
                <div className="simple-card">
                    <h2>Welcome to TuneTagger</h2>
                    <br />
                    <Form submit={this.submit} submit_text="Login">
                        <TextInput name="email" label="Email" required={true} />
                        <br />
                        <TextInput
                            type="password"
                            name="password"
                            label="Password"
                            required={true}
                        />
                        <br />
                    </Form>
                    {error}
                </div>
            </Container>
        );
    }
}

export default Login;
